/**********************************************************
Alexander Self
8/22/17
Irrigation container
**********************************************************/
import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { IRRIGATION_URLS } from '../constants';
import Tabs from '../components/tabs';
import './irrigation.css';

class IrrigationContainer extends Component {
  componentDidMount() {
    document.title = 'Irrigation';
  }
  render() {
    return (
      <div>
        <div className="row">
          <h5>Irrigation <span className="flow-text right">{ moment().format("dddd, MMMM Do YYYY") }</span></h5><hr />
          <Tabs id={"irrigation"} tabs={IRRIGATION_URLS} level={this.props.user.level} />
        </div>
        <div>
          { this.props.children }
        </div>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    user: state.auth.user
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({

  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(IrrigationContainer);



/* END */



// WEBPACK FOOTER //
// ./src/irrigation/irrigation_container.js